export default __webpack_public_path__ + "static/media/scene4.0c3c1d87.png";